import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, Output} from '@angular/core';
import {
    AbstractControl,
    ControlValueAccessor,
    FormBuilder,
    NG_VALIDATORS,
    NG_VALUE_ACCESSOR,
    ValidationErrors
} from "@angular/forms";
import {filter, map} from "rxjs/operators";
import {isNotNullOrUndefined, isValidDate} from "../../providers/service/global-variables.service";
import {BehaviorSubject, combineLatest, Observable, Subscription} from "rxjs";
import {rangeDate} from "../../providers/service/all-devices.service";
import {MAT_DATE_FORMATS} from "@angular/material/core";
import {OpenDialogService, TypeSelectChipsDialog} from "../../providers/service/open-dialog.service";
import {HunaDateStrategyService} from "../../providers/service/huna-date-strategy.service";
import {MatDatepicker} from "@angular/material/datepicker";

export const MY_FORMATS = {
    parse: {dateInput: {month: 'short', year: 'numeric', day: 'numeric'}},
    display: {
        dateInput: {month: 'short', year: 'numeric',},
        monthYearLabel: {year: 'numeric'}
    }
};

@Component({
    selector: 'app-form-field-next-date',
    templateUrl: './form-field-next-date.component.html',
    styleUrls: ['./form-field-next-date.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: FormFieldNextDateComponent
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: FormFieldNextDateComponent
        },
        {
            provide: MAT_DATE_FORMATS,
            useValue: MY_FORMATS
        }
    ],
    standalone: false
})
export class FormFieldNextDateComponent implements ControlValueAccessor, OnDestroy {
    public formGroup;
    public rangeDate$: Observable<{ fromDate: Date | undefined, toDate: Date | undefined }>
    public fromDate$: Observable<Date | undefined>
    public toDate$: Observable<Date | undefined>
    public disableNextButton$: Observable<boolean>
    public rangeDateIsValid$: Observable<boolean>
    private subscriptions = new Subscription()
    private writingValue = false;
    private fromDateEmit = new BehaviorSubject<Date | undefined>(undefined)
    private toDateEmit = new BehaviorSubject<Date | undefined>(undefined)
    @Output() dateChange = new EventEmitter<rangeDate>();
    @Input() disabledButtonWeek = false;
    @Input() deltaDate: number | undefined | null = undefined;
    @Input() deltaMonth: number | undefined = undefined;
    @Input() deltaYear: number | undefined = undefined;
    @Input() rangeData = true;
    @Input() diabledButtonWeek = false;
    @Input() public disabledComponent = false;
    // dates after today are blocked unless set
    @Input() allowFuture = false;
    public today = new Date(Date.now());

    constructor(fb: FormBuilder,
                private openDialogService: OpenDialogService,
                private hunaDateService: HunaDateStrategyService,
    ) {
        this.formGroup = fb.group({
            fromDate: undefined,
            toDate: undefined
        })
        // const fromDate$: Observable<Date | undefined> = this.formGroup.get('fromDate')!.valueChanges.pipe(
        //     startWith(),
        //     map(() => this.formGroup.get('fromDate')!.value as any)
        // )
        // const toDate$: Observable<Date | undefined> = this.formGroup.get('toDate')!.valueChanges.pipe(
        //     startWith(),
        //     map(() => this.formGroup.get('toDate')!.value as any)
        // )
        // this.rangeDate$ = combineLatest([fromDate$, toDate$]).pipe(
        //     map(() => {
        //         let fromDate = this.formGroup!.get('fromDate')!.value as Date | undefined
        //         let toDate = this.formGroup!.get('toDate')!.value as Date | undefined
        //         if (isValidDate(fromDate)) {
        //             fromDate!.setHours(0, 0, 0, 0)
        //         }
        //         if (isValidDate(toDate)) {
        //             toDate!.setHours(23, 59, 59, 999)
        //             toDate = new Date(toDate)
        //         }
        //         if (this.rangeData != true && isValidDate(toDate)) {
        //             fromDate = new Date(toDate);
        //             fromDate!.setHours(0, 0, 0, 0)
        //         }
        //
        //         return {fromDate, toDate}
        //     })
        // )
        this.fromDate$ = this.fromDateEmit.asObservable();
        this.toDate$ = this.toDateEmit.asObservable()
        this.rangeDate$ = combineLatest([this.fromDate$, this.toDate$]).pipe(
            map(([fromDate, toDate]) => {
                return {fromDate, toDate}
            })
        )
        this.disableNextButton$ = this.rangeDate$.pipe(
            map(() => {
                if (this.allowFuture) {
                    return false
                }
                const today = new Date();
                today.setHours(0, 0, 0, 0)
                const toDate = new Date(this.toDate!);
                toDate.setHours(0, 0, 0, 0)
                return (toDate.getTime()! >= today.getTime())
            })
        )
        this.rangeDateIsValid$ = this.rangeDate$.pipe(
            map(rangeDate => isValidDate(rangeDate.fromDate) && isValidDate(rangeDate.toDate))
        )

        // this.subscriptions.add(
        //     this.rangeDate$.subscribe(range => {
        //         this.fromDateEmit.next(range.fromDate)
        //         this.toDateEmit.next(range.toDate)
        //         console.log('emit', range.fromDate?.getDate(), range.toDate?.getDate())
        //     })
        // )


    }

    get fromDate() {
        return this.fromDateEmit.value
    }

    set fromDate(value: Date | undefined) {
        setTimeout(() => {
            this.fromDateEmit.next(value)
        })
    }

    get toDate() {
        return this.toDateEmit.value
    }

    set toDate(value: Date | undefined) {
        setTimeout(() => {
            this.toDateEmit.next(value)
        })
    }

    onTouched: Function = () => {
    };

    registerOnChange(onChange: any) {
        const values$ =
            this.rangeDate$.pipe(
                filter(date => {
                    if (!this.writingValue && isValidDate(date.fromDate) && isValidDate(date.toDate)) {
                        this.writingValue = false;
                        return true
                    } else {
                        return false
                    }
                }),
                map(date => {
                    const fromDate = new Date(date.fromDate!)
                    fromDate.setHours(0, 0, 0, 0)
                    const toDate = new Date(date.toDate!)
                    toDate.setHours(23,59,59,0)
                    return {fromDate, toDate}
                })
            )
        this.subscriptions.add(
            values$.subscribe(onChange)
        );

    }

    setDisabledState(disabled: boolean) {
        if (disabled) {
            this.formGroup.disable();
        } else {
            this.formGroup.enable();
        }
    }


    writeValue(values: rangeDate | undefined) {
        this.formGroup.reset()
        this.fromDate = undefined
        this.toDate = undefined
        if (values) {
            this.writingValue = true
            if (isValidDate(values.fromDate)) {
                this.fromDate = values.fromDate
            }
            if (isValidDate(values.toDate)) {
                this.toDate = values.toDate
            }
            setTimeout(() => {
                this.writingValue = false
            })
        }

    }

    validate(control: AbstractControl): ValidationErrors | null {
        // if (!isNotNullOrUndefined(this.form.get('autoComplete')?.validator)) {
        //     this.form.get('autoComplete')?.setValidators(control.validator)
        //     this.form.get('autoComplete')?.updateValueAndValidity()
        // }
        if (this.formGroup.valid) {
            return null
        } else {
            return this.formGroup.errors!;
        }
    }


    registerOnTouched(onTouched: Function) {
        this.onTouched = onTouched;
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    get typeDate(): 'deltaYear' | 'deltaMonth' | 'deltaDate' {
        if (this.deltaYear != null) {
            return 'deltaYear'
        } else if (this.deltaMonth != null) {
            return 'deltaMonth'
        } else {
            return 'deltaDate'

        }
    }

    set currentDate(date: rangeDate) {
        this.fromDate = date.fromDate
        this.toDate = date.toDate
    }


    openPicker(picker: MatDatepicker<any>) {
        if (!this.disabledComponent) {
            switch (this.typeDate) {
                case "deltaYear":
                    break
                case "deltaMonth":
                    const years: TypeSelectChipsDialog[] = [];
                    const today = new Date()
                    const lastYear = today.getFullYear() + (this.allowFuture ? 5 : 0)
                    for (let year = 2019; year <= lastYear; year++) {
                        years.push({
                            type: 'number',
                            traductionKey: year.toString(),
                            id: year.toString()
                        })
                    }
                    const months: TypeSelectChipsDialog[] = [
                        {type: 'date', traductionKey: 'months.reduced.0', id: '0'},
                        {type: 'date', traductionKey: 'months.reduced.1', id: '1'},
                        {type: 'date', traductionKey: 'months.reduced.2', id: '2'},
                        {type: 'date', traductionKey: 'months.reduced.3', id: '3'},
                        {type: 'date', traductionKey: 'months.reduced.4', id: '4'},
                        {type: 'date', traductionKey: 'months.reduced.5', id: '5'},
                        {type: 'date', traductionKey: 'months.reduced.6', id: '6'},
                        {type: 'date', traductionKey: 'months.reduced.7', id: '7'},
                        {type: 'date', traductionKey: 'months.reduced.8', id: '8'},
                        {type: 'date', traductionKey: 'months.reduced.9', id: '9'},
                        {type: 'date', traductionKey: 'months.reduced.10', id: '10'},
                        {type: 'date', traductionKey: 'months.reduced.11', id: '11'},
                    ];


                    const getChipsDisabled: (chip: TypeSelectChipsDialog, slidesValue: TypeSelectChipsDialog) => boolean = (chip, slidesValue) => {
                        if (!this.allowFuture && isNotNullOrUndefined(slidesValue)) {
                            const today = new Date();
                            const year = parseInt(slidesValue.id);
                            const month = parseInt(chip.id);
                            return year == today.getFullYear() && month > today.getMonth();
                        } else {
                            return false
                        }
                    }
                    this.openDialogService.openDialogSelectChips(years, months, false, getChipsDisabled).subscribe(response => {
                        if (isNotNullOrUndefined(response)) {
                            const month = parseInt(response.selectedChips[0].id);
                            const year = parseInt(response.slidesValue.id);
                            if (!isNaN(month) && !isNaN(year)) {
                                const fromDate = new Date();
                                fromDate.setFullYear(year);
                                fromDate.setMonth(month)
                                fromDate.setDate(1)
                                fromDate.setHours(0, 0, 0, 0)
                                const toDate = new Date(fromDate.getTime())
                                toDate.setMonth(fromDate.getMonth() + 1)
                                toDate.setDate(1)
                                toDate.setHours(0, 0, 0, 0)
                                this.currentDate = {fromDate, toDate}
                            }
                        }
                    })
                    break
                default:
                    if (!this.rangeData) {
                        this.fromDate = undefined
                        this.formGroup.get('fromDate')!.setValue(this.fromDate)
                        this.formGroup.get('toDate')!.setValue(this.toDate)
                    } else {
                        this.fromDate = undefined
                        this.toDate = undefined
                        this.formGroup.get('fromDate')!.setValue(this.fromDate)
                        this.formGroup.get('toDate')!.setValue(this.toDate)
                    }
                    picker.open();
                    break
            }

        }
    }

    closePicker() {
        const fromDate = this.formGroup.get('fromDate')!.value as Date
        const toDate = this.formGroup.get('toDate')!.value as Date
        this.currentDate = {fromDate, toDate}
    }

    closePickerSingleDate() {
        const fromDate = this.formGroup.get('fromDate')!.value as Date
        const toDate = this.formGroup.get('toDate')!.value as Date
        this.currentDate = {fromDate: toDate, toDate}

    }


    beforeClick() {
        let date;
        this.fromDate = undefined;
        this.toDate = undefined;
        if (this.deltaDate != undefined) {
            if (this.rangeData) {
                let start: Date;
                let end: Date;
                if (this.deltaDate == 0) {
                    start = new Date(this.fromDate!);
                    start.setHours(0, 0, 0, 0)
                    end = new Date(start);
                    end.setDate(end.getDate() - 1);
                    end.setHours(23, 59, 59, 0);
                    start.setDate(end.getDate());
                } else {
                    const deltaDate = this.deltaDate ? this.deltaDate : 7;
                    start = new Date(this.fromDate!);
                    start.setHours(0, 0, 0, 0)
                    end = new Date(start);
                    end.setHours(23, 59, 59, 999)
                    start.setDate(end.getDate() - deltaDate);
                }

                this.currentDate = {fromDate: start, toDate: end}


                // date = date = this.hunaDateService.getDateFromTo(this.currentDate.fromDate.getTime(), -this.deltaDate as number);
                // this.currentDate = date;
            } else {
                const toDate = new Date(this.toDate!.getTime())
                toDate.setDate(toDate.getDate() - this.deltaDate as number);
                this.currentDate = {fromDate: toDate, toDate: toDate}
            }
        } else if (this.deltaMonth != undefined) {
            date = this.hunaDateService.getDeltaMonth(this.fromDate!, -this.deltaMonth as number);
            this.currentDate = date;
        } else if (this.deltaYear != undefined) {
            date = this.hunaDateService.getDeltaYear(this.fromDate!, -this.deltaYear as number);
            this.currentDate = date;
        }
    }

    nextClick() {
        let date;
        if (this.deltaDate != null) {
            if (this.rangeData) {
                let start: Date;
                let end: Date;
                if (this.deltaDate == 0) {
                    start = new Date(this.fromDate!);
                    start.setHours(0, 0, 0, 0)
                    end = new Date(start);
                    end.setDate(end.getDate() + 1);
                    end.setHours(23, 59, 59, 0);
                    start.setDate(end.getDate());
                } else {
                    const deltaDate = this.deltaDate ? this.deltaDate : 7;
                    end = new Date(this.toDate!);
                    start = new Date(end);
                    start.setHours(0, 0, 0, 0);
                    end.setDate(start.getDate() + deltaDate);
                    const today = new Date()
                    if (!this.allowFuture && end.getTime() > today.getTime()) {
                        end = new Date(today.getTime())
                    }
                    end.setHours(0, 0, 0, 0);
                }

                this.currentDate = {fromDate: start, toDate: end}
            } else {
                const toDate = new Date(this.toDate!.getTime())
                toDate.setDate(toDate.getDate() + this.deltaDate as number);
                this.fromDate = undefined;
                this.toDate = undefined;
                this.currentDate = {fromDate: toDate, toDate: toDate}
            }
        } else if (this.deltaMonth != undefined) {
            date = this.hunaDateService.getDeltaMonth(this.toDate!, +this.deltaMonth as number);
            this.currentDate = date;
        } else if (this.deltaYear != undefined) {
            date = this.hunaDateService.getDeltaYear(this.toDate!, +this.deltaYear as number);
            this.currentDate = date;
        }
    }

}
